import ConfettiExplosion from 'react-confetti-explosion';
import { useWheelData } from '@lib/hooks/useWheelData';

const ConfettiItems = (props) => {
  const bigExplodeProps = {
    force: 0.4, duration: 3000, particleCount: 50, floorHeight: 4000, floorWidth: '100vh', zIndex: 1000
  };

  const topRightSource = {
    position: 'absolute', right: '80%', left: '20%'
  };

  const topSource = {
    position: 'absolute', right: '50%', left: '50%', top: '10%'
  };

  const topLeftSource = {
    position: 'absolute', right: '20%', left: '90%'
  };

  const midSource = {
    position: 'absolute', right: '50%', left: '50%', top: '40%'
  };

  const midRightSource = {
    position: 'absolute', right: '70%', left: '30%', top: '40%'
  };

  const midLeftSource = {
    position: 'absolute', right: '30%', left: '70%', top: '40%'
  };

  const bottomRightSource = {
    position: 'absolute', right: '10%', left: '90%', bottom: '20%'
  };

  const bottomLeftSource = {
    position: 'absolute', right: '90%', left: '10%', bottom: '20%'
  };

  const { isExploding, setIsExploding, setting } = useWheelData(s => ({
    isExploding: s.isExploding,
    setIsExploding: s.setIsExploding,
    setting: s.setting,
  }));

  function handleConfettiComplete() {
    setIsExploding(false);
  }

  return (
    <div>
      {isExploding && setting?.enableConfetti && (
        <>
          <div style={topRightSource}>
            <ConfettiExplosion {...bigExplodeProps} onComplete={handleConfettiComplete} />
          </div>

          <div style={topSource}>
            <ConfettiExplosion {...bigExplodeProps} />
          </div>

          <div style={topLeftSource}>
            <ConfettiExplosion {...bigExplodeProps} />
          </div>

          <div style={midRightSource}>
            <ConfettiExplosion {...bigExplodeProps} />
          </div>

          <div style={midSource}>
            <ConfettiExplosion {...bigExplodeProps} />
          </div>

          <div style={midLeftSource}>
            <ConfettiExplosion {...bigExplodeProps} />
          </div>

          <div style={bottomRightSource}>
            <ConfettiExplosion {...bigExplodeProps} />
          </div>

          <div style={bottomLeftSource}>
            <ConfettiExplosion {...bigExplodeProps} />
          </div>
        </>
      )}
    </div>
  );
};

export default ConfettiItems;
